import 'styles/globals.css'
import { appWithTranslation } from 'next-i18next'
import type { AppProps } from 'next/app'
import theme from '@/assets/theme/theme'
import { ThemeProvider } from '@mui/material/styles'

import { GlobalContextProvider } from 'context/GlobalContextProvider'
import { CartProvider } from 'context/CartContext'

function App({ Component, pageProps }: AppProps) {
  return (
    <ThemeProvider theme={theme}>
      <GlobalContextProvider>
        <CartProvider>
          <Component {...pageProps} />
        </CartProvider>
      </GlobalContextProvider>
    </ThemeProvider>
  )
}

export default appWithTranslation(App)
